import { apiRequest } from "./api";
import type {
  GuardianApprovalRequest,
  GuardianApprovalResponse,
  GuardianRequestCreateRequest,
  GuardianRequestDecisionRequest,
  GuardianRequestResponse,
  GuardianTeenDetailResponse,
} from "../types/guardianTypes";
import type { StripeOnboardingLinkResponse, StripePayoutProfileResponse } from "../types/stripeTypes";

export const guardianApi = {
  createRequest(payload: GuardianRequestCreateRequest): Promise<GuardianRequestResponse> {
    return apiRequest<GuardianRequestResponse>("/api/guardian/requests", {
      method: "POST",
      body: payload,
    });
  },

  decideRequest(otherUserId: string, payload: GuardianRequestDecisionRequest): Promise<GuardianRequestResponse> {
    return apiRequest<GuardianRequestResponse>(`/api/guardian/requests/${otherUserId}/decision`, {
      method: "POST",
      body: payload,
    });
  },

  listTeenIncoming(): Promise<GuardianRequestResponse[]> {
    return apiRequest<GuardianRequestResponse[]>("/api/teen/guardian-requests/incoming", { method: "GET" });
  },

  listTeenOutgoing(): Promise<GuardianRequestResponse[]> {
    return apiRequest<GuardianRequestResponse[]>("/api/teen/guardian-requests/outgoing", { method: "GET" });
  },

  listAdultIncoming(): Promise<GuardianRequestResponse[]> {
    return apiRequest<GuardianRequestResponse[]>("/api/adult/guardian-requests/incoming", { method: "GET" });
  },

  listAdultOutgoing(): Promise<GuardianRequestResponse[]> {
    return apiRequest<GuardianRequestResponse[]>("/api/adult/guardian-requests/outgoing", { method: "GET" });
  },

  getTeenDetail(teenId: string): Promise<GuardianTeenDetailResponse> {
    return apiRequest<GuardianTeenDetailResponse>(`/api/adult/guardian/teens/${teenId}`, { method: "GET" });
  },

  getTeenPayoutProfile(teenId: string): Promise<StripePayoutProfileResponse> {
    return apiRequest<StripePayoutProfileResponse>(`/api/adult/guardian/teens/${teenId}/stripe/payout-profile`, { method: "GET" });
  },

  createTeenPayoutOnboardingLink(teenId: string): Promise<StripeOnboardingLinkResponse> {
    return apiRequest<StripeOnboardingLinkResponse>(`/api/adult/guardian/teens/${teenId}/stripe/payout-profile/onboarding-link`, {
      method: "POST",
    });
  },

  createApproval(requestId: string, payload: GuardianApprovalRequest): Promise<GuardianApprovalResponse> {
    return apiRequest<GuardianApprovalResponse>(`/api/guardian/approvals/${requestId}`, {
      method: "POST",
      body: payload,
    });
  },
};
